export default __webpack_public_path__ + "static/media/VinodBG.8e668504.webp";